import { getXCLEARCorrelationInfo } from '@api/utils'
import { applyLabelOverrides } from '@utils/documentCheckCriteria'
import { LookupList } from '@clear-denver/tpc-openapi-typescript/build/v1/lookup'
import { array, object, string, SchemaOf } from 'yup'

// A schema can't be derived from LookupList — TS types are erased before runtime — but SchemaOf
// constrains it the other way, so the generated OpenAPI type drifting from this shape is a
// compile error rather than something we find in production.
const lookupListsSchema: SchemaOf<LookupList[]> = array()
  .of(
    object().shape({
      category: string().required(),
      values: array()
        .min(1)
        .of(
          object().shape({
            key: string().required(),
            text: string().required(),
          })
        )
        .required(),
    })
  )
  .required()

// strict so a wrong-typed field fails instead of being coerced to a string.
const isLookupLists = (value: unknown): value is LookupList[] =>
  lookupListsSchema.isValidSync(value, { strict: true })

export const baseLookup = async (key: string) => {
  const response = await fetch(
    `${process.env.NEXT_PUBLIC_LOOKUP_API_ENDPOINT}/lookup?categories=${key}`,
    {
      headers: {
        'X-CLEAR-CorrelationInfo': getXCLEARCorrelationInfo(),
      },
    }
  )

  // An unknown or unloaded category comes back as an empty array, so callers have to cope with
  // no options either way; a malformed response gets the same treatment rather than a TypeError
  // out of data[0].
  const data: unknown = await response.json()
  if (!isLookupLists(data) || data.length === 0) {
    return []
  }

  // Every lookup label the app renders comes through here, so overriding once covers the
  // photo ID dropdown and the confirmation page's "what to bring" list alike.
  return applyLabelOverrides(
    key,
    data[0].values.map((x) => ({
      label: x.text,
      value: x.key,
    }))
  )
}
